import { render, staticRenderFns } from "./EditItemForClients.vue?vue&type=template&id=0fd027f0&scoped=true"
import script from "./EditItemForClients.vue?vue&type=script&lang=js"
export * from "./EditItemForClients.vue?vue&type=script&lang=js"
import style0 from "./EditItemForClients.vue?vue&type=style&index=0&id=0fd027f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd027f0",
  null
  
)

export default component.exports